import {dropdownOption} from '../../../shapes';
import LoadingIndicator from '../../../../LoadingIndicator/LoadingIndicator';
import {useCanvasFormMetadata} from '../../../../../../util/customHooks';
import PropTypes from 'prop-types';
import React, {useCallback, useState} from 'react';
import styled from 'styled-components';
import DropdownItem from '../../../../BaseComponentWrappers/MotifDropdownItem';
import Dropdown from '../../../../BaseComponentWrappers/MotifDropdown';
import MotifButton from '@ey/motif-react-wrapper/IconButton';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {IconoirCustomMoreVerticalAlt} from '@ey-xd/motif-icon';

export const BodySpecialAccordionHeaderOverflow = ({className, isOpen, setIsOpen, config}) => {
	const [isLoading, setIsLoading] = useState(false);

	const {isTargetEngagement} = useCanvasFormMetadata();

	const handleOnClick = useCallback(() => {
		setIsOpen(!isOpen);
	}, [isOpen]);

	const handleClickOutside = useCallback(() => {
		setIsOpen(false);
	}, []);

	// Default filters that apply to ALL ISA body types
	const isItemVisible = (item) => {
		let returnValue = true;

		if (item.name?.toLowerCase() === 'delete' || item.name?.toLowerCase() === 'edit') {
			if (isTargetEngagement) {
				returnValue = false;
			}
		}

		return returnValue;
	};

	let filteredOptions = [];
	if (config && config.length > 0) {
		filteredOptions = config.filter((item) => (item.isVisible === undefined && isItemVisible(item)) || item.isVisible);
	}

	return (
		<StyledBodySpecialAccordionHeaderOverflow className={`StyledBodySpecialAccordionHeaderOverflow ${className}`}>
			<LoadingIndicator show={isLoading} fullscreen />
			<Dropdown
				open={isOpen}
				portalClassName="specialBodyAccordionHeaderOverflowDropDown"
				closeOnOutsideClick
				usePortal
				trigger={
					<MotifButton className="MoreDropdownButton" variant="text" type="button" onClick={handleOnClick}>
						<MotifIcon src={IconoirCustomMoreVerticalAlt} />
					</MotifButton>
				}
			>
				{filteredOptions.map((item, idx) => (
					<DropdownItem
						key={idx}
						onClick={() => {
							item.onClick && item.onClick();
							setIsOpen(false);
						}}
						children={React.cloneElement(item.render, {isLoading, setIsLoading})}
					/>
				))}
			</Dropdown>
		</StyledBodySpecialAccordionHeaderOverflow>
	);
};

BodySpecialAccordionHeaderOverflow.displayName = 'BodySpecialAccordionHeaderOverflow';

BodySpecialAccordionHeaderOverflow.propTypes = {
	className: PropTypes.string,
	isOpen: PropTypes.bool,
	setIsOpen: PropTypes.func.isRequired,
	config: PropTypes.arrayOf(dropdownOption)
};

BodySpecialAccordionHeaderOverflow.defaultProps = {
	className: 'body-special-accordion-header-overflow',
	isOpen: false
};

export default BodySpecialAccordionHeaderOverflow;

const StyledBodySpecialAccordionHeaderOverflow = styled.section`
	height: 100%;
	display: flex;
	align-items: center;
	width: var(--px-35);
	justify-content: center;
	border-bottom: 0 !important;
	.MoreDropdownButton {
		.motif-icon {
			svg {
				color: var(--neutrals-900);
				width: var(--px-20);
				height: var(--px-20);
			}
		}
	}
`;
